<div *ngIf="isMobile && activeBid; else webLogin" class="full-container">
  <div class="strike-container">
    <div class="top-content">
      <div class="bid-card">
        <div
          class="bid-details-and-edit"
          [ngClass]="{ 'with-padding': strike }"
        >
          <div
            [ngClass]="{
              'type-bid-details-mobile-buy':
                activeBid.transaction_type === 'Buy',
              'type-bid-details-mobile-sell':
                activeBid.transaction_type === 'Sell'
            }"
          >
            <span class="type-mobile">{{ activeBid.transaction_type }}</span> -
            Bid details
          </div>
          <div *ngIf="!strike">
            <img
              (click)="!strike && openEditBidModal()"
              class="edit-icon-mobile"
              [class.disabled]="strike"
              src="assets/edit_icon.png"
              alt="edit"
              [attr.aria-disabled]="strike"
            />
          </div>
        </div>
        <div class="bid-info-mobile">
          <div class="bid-first-column-mobile">
            <div class="top-label-mobile">
              Type <br />
              <span>{{ activeBid.bid_type }}</span>
            </div>
            <div class="bid-values-mobile">
              <span>{{ activeBid.energy_amount }}</span> Units (KWh)
            </div>
          </div>
          <div class="bid-second-column-mobile">
            <div class="top-label-mobile">
              From <br />
              <span>{{ activeBid.from_date }}</span>
            </div>
            <div class="bid-values-mobile">
              &amp;#64; <span>{{ activeBid.bid_price }}</span> Rs.
            </div>
          </div>
        </div>
      </div>
      <div class="middle-content">
        <div class="bid-details-mobile">
          Bid is Open from {{ activeBid.bid_start }} to {{ activeBid.bid_end }}
        </div>
        <div class="strike-price-info-mobile" *ngIf="!strike">
          <div class="strike-price-reminder">
            Once the Bid closes at {{ activeBid.bid_end }} <br />
            {{ bidRound.price_label }} will be displayed.
          </div>
          <div class="strike-price-details-mobile">
            <div class="strike-price-label-mobile">
              {{ bidRound.price_label }}
            </div>
            <div class="divider-mobile"></div>
            <div class="strike-price-mobile">-- Not Available Yet --</div>
          </div>
        </div>
        <div class="strike-price-info-mobile" *ngIf="strike">
          <div class="strike-price-reminder">
            Today's Bid is closed at {{ bidRound.close_time }} <br />
            ( {{ bidRound.close_date }} )
          </div>
          <div class="strike-price-details-mobile">
            <div class="strike-price-label-mobile">
              {{ bidRound.price_label }}
            </div>
            <div class="second-divider-mobile"></div>
            <div class="strike-price-mobile-currency">
              {{ strikePrice }} <span class="currency-mobile">Rs.</span>
            </div>
          </div>
        </div>
        <div
          class="accept-or-reject-mobile"
          [ngClass]="{ 'not-strike': !strike, strike: strike }"
        >
          You can Accept or Reject this price
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="reject-and-accept-buttons">
        <div class="reject-button-mobile">
          <button
            (click)="handleAcceptance(false)"
            type="submit"
            [disabled]="!strike"
          >
            Reject
          </button>
        </div>
        <div class="accept-button-mobile">
          <button
            (click)="handleAcceptance(true)"
            type="submit"
            [disabled]="!strike"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <body>
    <div *ngIf="activeBid" class="container">
      <div class="content">
        <div class="details">
          <div class="column">
            <div class="bid-info">
              <div
                [ngClass]="{
                  'bid-info-buy': activeBid.transaction_type === 'Buy',
                  'bid-info-sell': activeBid.transaction_type === 'Sell'
                }"
              >
                <div class="bid-type">
                  <span>Bid Type</span>: {{ activeBid.transaction_type }}
                </div>
              </div>
              <!-- <div *ngIf="isLoading" class="loading-web">
                {{
                  userBidAction
                    ? "Accepting your bid, please wait..."
                    : "Rejecting your bid, please wait..."
                }}
              </div> -->
              <div *ngIf="isLoading" class="loading-web">
                {{ loadingMessage }}
              </div>
              <div *ngIf="isFinalizingUpdate" class="loading-web">
                <span>{{ finalizeMessage }}</span>
              </div>

              <div class="header-text">
                You have already placed the below Bid
              </div>
              <div class="field">Bid Category</div>
              <div class="value">{{ activeBid.bid_type }}</div>
              <div class="field">Number of Units [Kwh]</div>
              <div class="value">{{ activeBid.energy_amount }}</div>
              <div class="field">From Date</div>
              <div class="value">{{ activeBid.from_date }}</div>
              <div class="field">
                {{ activeBid.transaction_type }} - Bid rate [Rs.]
              </div>
              <div class="value">{{ activeBid.bid_price }}</div>
              <div *ngIf="!strike && activeBid.status !== 'CANCELLED'">
                <button
                  (click)="openEditBidModal()"
                  type="submit"
                  class="edit-button"
                  [disabled]="strike || isLoading"
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="strike-price-info">
              <div class="bid-status">
                <div class="bid-status-title">Bid Status</div>
                <div
                  [ngClass]="{
                    'bid-status-pending': activeBid.status === 'PENDING',
                    'bid-status-active': activeBid.status === 'ACTIVE',
                    'bid-status-rejected': activeBid.status === 'REJECTED',
                    'bid-status-cancelled': activeBid.status === 'CANCELLED'
                  }"
                  *ngIf="activeBid.status"
                >
                  <img
                    class="green-dot"
                    *ngIf="activeBid.status === 'ACTIVE'"
                    src="assets/green-dot.svg"
                    alt="green dot"
                  />
                  <img
                    class="yellow-dot"
                    *ngIf="activeBid.status === 'PENDING'"
                    src="assets/yellow-dot.svg"
                    alt="yellow dot"
                  />
                  <img
                    class="red-dot"
                    *ngIf="
                      activeBid.status === 'REJECTED' ||
                      activeBid.status === 'CANCELLED'
                    "
                    src="assets/red-dot.svg"
                    alt="red dot"
                  />
                  {{ activeBid.status }}
                </div>
              </div>
              <div class="notice">
                Note: Bid is Open from {{ activeBid.bid_start }} to
                {{ activeBid.bid_end }}
              </div>
              <div class="strike" *ngIf="!strike">
                <div class="instructions">
                  Once the Bid closes at {{ activeBid.bid_end }}
                  <br />
                  {{ bidRound.price_label }} will be displayed Here
                </div>
                <div class="action-info">
                  You can Accept or Reject the price
                </div>
                <div class="strike-price">{{ bidRound.price_label }}</div>
                <div class="separator"></div>
                <div class="price-status">-- Not Available yet --</div>
              </div>

              <div class="strike" *ngIf="strike">
                <div class="instructions">
                  Bid has closed at {{ bidRound.close_time }}
                  <br />
                  Date:{{ bidRound.close_date }}
                </div>
                <div class="strike-price">{{ bidRound.price_label }}</div>
                <div class="separator"></div>
                <div class="strike-value">
                  {{ strikePrice }} <span class="currency">Rs</span>
                </div>

                <div class="price-status">
                  You can Accept or Reject the price
                </div>
                <div class="instructions warning">
                  If the {{ bidRound.price_label }} is not accepted by
                  {{ this.endAllocation }}, it will be automatically rejected
                </div>
              </div>
              <div class="actions" *ngIf="activeBid.status !== 'CANCELLED'">
                <div *ngIf="!strike">
                  <button
                    (click)="withdrawBid()"
                    type="submit"
                    [disabled]="isLoading"
                    class="withdraw-button"
                  >
                    Withdraw Bid
                  </button>
                </div>
                <div *ngIf="strike" class="actions">
                  <button
                    (click)="handleAcceptance(false)"
                    type="submit"
                    [disabled]="!strike || isLoading"
                    class="reject-button"
                  >
                    Reject
                  </button>
                  <button
                    (click)="handleAcceptance(true)"
                    type="submit"
                    [disabled]="!strike || isLoading"
                    class="accept-button"
                  >
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</ng-template>
